<template>
  <div class="evaluation-item">
    <div class="evaluation-item-store" @click="goDetail(item)">
      <img :src="item.storePic" />
      <span>{{ item.storeName }}</span>
    </div>
    <div class="evaluation-item-good" @click="goDetail(item)">
      <img :src="item.commodityPic" class="cover" />
      <div class="content">
        <div class="name _ellipsis2">
          {{ item.commodityName }}
        </div>
        <div class="sku">
          {{ item.commodityServiceSpecs }}
        </div>
      </div>
      <div class="extra">
        <div class="price">
          <span class="unit">¥</span>{{ item.commodityPrice }}
        </div>
        <div class="count">x{{ item.commodityQuantity }}</div>
      </div>
    </div>

    <div :class="['evaluation-item-text']">
      {{ item.evaluateContent }}
    </div>
    <div
      :class="{
        'evaluation-item-img': true,
        'style-2': [1, 2].includes(item.evaluatePic.length),
      }"
    >
      <img
        v-for="(url, index) in item.evaluatePic"
        :key="index"
        :src="url"
        @click="handleImageClick(item.evaluatePic, index)"
      />
    </div>
    <div
      v-if="item.evaluateAddContent || item.evaluateAddPic.length"
      class="evaluation-item-add"
    >
      <div class="title">我的追评</div>
      <span>{{ item.evaluateAddContent }}</span>

      <div
        :class="{
          'evaluation-item-img': true,
          'style-2': [1, 2].includes(item.evaluateAddPic.length),
        }"
      >
        <img
          v-for="(url, index) in item.evaluateAddPic"
          :key="index"
          :src="url"
          @click="handleImageClick(item.evaluateAddPic, index)"
        />
      </div>
    </div>
    <div v-if="item.replyContent" class="evaluation-item-reply">
      <div>商家回复</div>
      <span>{{ item.replyContent }}</span>
    </div>
    <div class="evaluation-item-date">
      <span>{{ date }}</span>
      <div class="flex-auto"></div>
      <img
        v-if="item.thumbsUpFlag"
        src="https://app-frontend.oss-cn-hangzhou.aliyuncs.com/duoduo-mall/img/commodity/approval2.png"
        @click="thumbsUpOrDown"
      />
      <img
        v-else
        src="https://app-frontend.oss-cn-hangzhou.aliyuncs.com/duoduo-mall/img/commodity/approval.png"
        @click="thumbsUpOrDown"
      />
      <a @click="thumbsUpOrDown">{{ item.thumbsUpCount }}</a>
    </div>
  </div>
</template>

<script>
  import { apiEvaluationEvaluateThumbsUpOrDown } from '@/api'
  import { ImagePreview } from 'vant'
  import { navigateTo } from '@/router'

  export default {
    props: {
      item: {
        type: Object,
        default: () => Object,
      },
      fromGoodsDetail: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      date() {
        const date = new Date()
        const end = new Date(this.item.createTime.replace(/-/g, '/'))
        const delta = (date - end) / 1000 / 60
        if (delta < 1) {
          return '刚刚'
        } else if (delta < 60) {
          return `${Math.round(delta)}分钟前`
        }
        const tmp = new Date()
        tmp.setDate(tmp.getDate() - 1)
        if (
          tmp.getFullYear() === end.getFullYear() &&
          tmp.getMonth() === end.getMonth() &&
          tmp.getDate() === end.getDate()
        ) {
          return `昨天${String(end.getHours()).padStart(2, '0')}:${String(
            end.getMinutes(),
          ).padStart(2, '0')}`
        } else if (date.getFullYear() === end.getFullYear()) {
          return `${String(end.getMonth() + 1).padStart(2, '0')}月${String(
            end.getDate(),
          ).padStart(2, '0')}日`
        }
        return `${String(end.getFullYear()).padStart(2, '0')}年${String(
          end.getMonth() + 1,
        ).padStart(2, '0')}月${String(end.getDate()).padStart(2, '0')}日`
      },
    },
    methods: {
      async thumbsUpOrDown() {
        await apiEvaluationEvaluateThumbsUpOrDown({ id: this.item.id })

        if (!this.item.thumbsUpFlag) {
          // eslint-disable-next-line vue/no-mutating-props
          this.item.thumbsUpFlag = 1
          // eslint-disable-next-line vue/no-mutating-props
          this.item.thumbsUpCount++
        } else {
          // eslint-disable-next-line vue/no-mutating-props
          this.item.thumbsUpFlag = 0
          // eslint-disable-next-line vue/no-mutating-props
          this.item.thumbsUpCount--
          if (this.item.thumbsUpCount < 0) {
            // eslint-disable-next-line vue/no-mutating-props
            this.item.thumbsUpCount = 0
          }
        }

        this.$forceUpdate()
        // this.goto({contentId: this.item.id, contentName: '取消点赞'})
      },

      handleImageClick(list, index) {
        ImagePreview({
          images: list,
          startPosition: index,
        })
      },
      goDetail(item) {
        navigateTo('GoodsIndex', { id: item.commodityId })
      },
    },
  }
</script>

<style scoped lang="scss">
  .evaluation-item {
    &-store {
      display: flex;
      align-items: center;
      img {
        width: 26px;
        height: 26px;
        margin-right: 12px;
        border-radius: 50%;
        object-fit: cover;
      }
      span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #222222;
        line-height: 20px;
        text-align: left;
        font-style: normal;
      }
    }

    &-good {
      margin-top: 13px;
      padding-bottom: 12px;
      display: flex;
      border-bottom: 1px solid #eeeeee;
      .cover {
        flex-shrink: 0;
        width: 80px;
        height: 80px;
        margin-right: 12px;
        border-radius: 8px;
        object-fit: cover;
      }

      .content {
        flex: 1;
        .name {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #222222;
          line-height: 18px;
          text-align: left;
          font-style: normal;
        }
        .sku {
          margin-top: 7px;
          display: inline-block;
          background: #f5f6f8;
          border-radius: 11px;
          padding: 2px 6px 3px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 10px;
          color: #888888;
          line-height: 12px;
          text-align: center;
          font-style: normal;
        }
      }

      .extra {
        margin-left: 40px;
        flex-shrink: 0;
        text-align: right;
        .price {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #222222;
          line-height: 18px;
          font-style: normal;
          .unit {
            font-size: 10px;
            margin-right: 2px;
          }
        }
        .count {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #222222;
          line-height: 16px;

          font-style: normal;
        }
      }
    }

    &-text {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
      line-height: 20px;
      margin-top: 12px;
    }

    &-img {
      display: flex;
      flex-wrap: wrap;
      margin-top: 4px;
      width: calc(100% + 12px);

      img {
        width: 112px;
        height: 112px;
        border-radius: 6px;
        margin-top: 8px;
        margin-right: 7px;
      }
    }

    &-add {
      .title {
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ff111c;
        line-height: 20px;
        margin-top: 12px;
      }

      span {
        display: block;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
        line-height: 20px;
        margin-top: 8px;
      }
    }

    &-reply {
      background: #f5f6f8;
      border-radius: 8px;
      padding: 12px;
      margin-top: 8px;

      div {
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #222222;
        line-height: 20px;
      }

      span {
        display: block;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
        line-height: 20px;
        margin-top: 8px;
      }
    }

    &-date {
      display: flex;
      align-items: center;
      margin-top: 13px;

      .flex-auto {
        flex: auto;
      }

      span {
        height: 12px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #bebebe;
        line-height: 12px;
      }

      img {
        width: 14px;
        height: 14px;
      }

      a {
        height: 16px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #888888;
        line-height: 16px;
        padding-left: 3px;
      }
    }
  }

  ::v-deep {
    .evaluation-item-img {
      img {
        object-fit: cover;
      }
      &.style-2 img {
        width: 172px;
        height: 172px;
      }

      &.max-4 {
        img {
          width: 76px;
          height: 76px;
          margin-right: 8px;
        }
      }
    }
  }
</style>
